import React from "react";
import PropTypes from "prop-types";
import Field from "../components/Form/Field";

const Question = ({ question, onChange, onSubmit }) => {
  const { key, label, options, type } = question;

  return (
    <Field
      type={type}
      name={key}
      label={label}
      choices={options}
      onChange={onChange}
      onSubmit={onSubmit}
    />
  );
};

Question.propTypes = {
  question: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
};

export default Question;
